import { type GoogleMapsOptions } from "./component";

const scriptCache = {};

export const loadGoogleScripts = (googleKey: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (googleKey in scriptCache) {
      resolve();
    } else {
      $.getScript(`//maps.googleapis.com/maps/api/js?v=3.exp&key=${googleKey}`, () => {
        scriptCache[googleKey] = null;
        resolve();
      }).fail((err) => reject(err));
    }
  });
};

export const initGoogleMaps = (element: HTMLElement, options: GoogleMapsOptions) => {
  $(element).gMap({
    address: options.address,
    maptype: options.type,
    zoom: typeof options.zoom === "undefined" ? 1 : options.zoom,
    markers: [
      {
        address: options.address,
        html: options.address
      },
      {
        address: options.address2,
        html: options.address2
      },
      {
        address: options.address3,
        html: options.address3
      }
    ],
    doubleclickzoom: false,
    controls: {
      panControl: true,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false
    }
  });
};
